import "./Contact.css";
import "./ContactResponsive.css";

import Banner from "../../shared/banner/Banner";
import ContactForm from "../../widgets/contact-form/ContactForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import CustomAnchor from "../../shared/Anchor/CustomAnchor";
import { Link } from "react-router-dom";

function Contact() {
  return (
    <>
      <Banner>
        <span>CONTACT</span>
        <span>US</span>
      </Banner>

      <div className="fluid-container">
        <div className="row m-0 contact-us-container">
          <div className="col-md-6 col-12 contact-details">
            <h1>ASK US ANYTHING</h1>
            <div className="d-block">
              <span>
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="contact-detail-icon"
                />
              </span>
              <span>Northern Farm Food Empowerment Zone Diepsloot Ward 96</span>
            </div>
            <div className="d-block">
              <span>
                <FontAwesomeIcon
                  icon={faPhone}
                  className="contact-detail-icon"
                />
              </span>
              <span>
                <Link to="tel:+27722480000">0722480000</Link>
              </span>
            </div>
            <div className="d-block">
              <span>
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="contact-detail-icon"
                />
              </span>
              <span>
                <Link to="mailto:brian@standout.africa">
                  brian@standout.africa
                </Link>
                <br />
                <Link to="mailto:brian.ndou2012@gmail.com">
                  brian.ndou2012@gmail.com
                </Link>
              </span>
            </div>
            <div className="d-block">
              <span>
                <FontAwesomeIcon
                  icon={faFacebook}
                  className="contact-detail-icon"
                />
              </span>
              <span>
                <CustomAnchor
                  path="https://web.facebook.com/profile.php?id=100076482242670"
                  classname="footer-fb-icon"
                >
                  Standout Fresh Produce
                </CustomAnchor>
              </span>
            </div>
          </div>
          <div className="col-md-6 col-12 contact-form">
            <div className="contact-wrapper">
              <div className="overlay"></div>
              <ContactForm />
            </div>
          </div>
        </div>
        <div className="row m-0">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3587.966374345845!2d27.98781897615848!3d-25.936328853119495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e957962467041c7%3A0x5a0fbae0f5a537e5!2sStandout%20Fresh%20Produce!5e0!3m2!1sen!2sza!4v1750543733801!5m2!1sen!2sza"
            title="Standout Fresh Produce Direction Map"
            width="600"
            height="600"
            style={{
              border: 0,
              margin: 0,
              padding: 0,
            }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </>
  );
}

export default Contact;
